<template>
  <div>
    <PcHead></PcHead>
    <!-- 智慧医疗 -->
    <div class="p-warp">
      <p class="p-title">智慧医疗 无缝佰医</p>
      <div class="p-img">
        <img class="p-gif" src="./../../../assets/boao/downL.gif" alt="">
      </div>
      <!-- 远程医疗系统 -->
      <div class="p-system">
        <p>TELEMEDICINE SYSTEM</p>
        <p class="p-system-title">远程医疗系统</p>
        <img src="./../../../assets/Pc/product1.png" alt="">
        <p class="p-system-title">产品优势</p>
        <div class="p-content">
          <div class="p-service-right">
            <span class="p-round p-round-two"></span>
            <span class="p-round"></span>
            <p class="p-service-head">大幅增加便捷性</p>
            <p class="p-service-text">
              <img src="./../../../assets/Pc/sanjiao.png" alt="" style="margin:10px 10px 0 0"> 改会诊中心接入模式为多屏接入模式：医生通过电脑、手机、会诊中心均可以接入远程医疗系统，便于在省市及地方县镇乡村广泛落地，极大降低了落地成本，加快了落地效率。<br/>
              <img src="./../../../assets/Pc/sanjiao.png" alt="" style="margin:10px 10px 0 0"> 改会诊中心对会诊中心模式为医生对医生模式：基于会诊中心制定的会诊流程和管理制度，医生与医生之间能够自主发起会诊，使复杂流程得以简化，大幅增加会诊便利性，并大幅降低会诊中心的工作量。<br/>
              <img src="./../../../assets/Pc/sanjiao.png" alt="" style="margin:10px 10px 0 0"> 改病历手动复制为病历自动提取：会诊病历数据可以通过与院内系统对接的方式，实现数据的自动同步，便捷医生操作，并有效提高会诊质量。
            </p>
          </div>
          <div class="p-service-right">
            <span class="p-round p-round-two"></span>
            <span class="p-round"></span>
            <p class="p-service-head">激励明确并及时发放到位</p>
            <p class="p-service-text">
              制定合理规范的激励政策和绩效考核制度，有专门的财务系统后台，通过自动化结算系统，实现会诊后医生诊费的及时获得并合规完税
            </p>
          </div>
          <div class="p-service-right">
            <span class="p-round p-round-two"></span>
            <span class="p-round"></span>
            <p class="p-service-head">会诊全过程全程监督</p>
            <p class="p-service-text">
              根据《远程会诊管理办法》，使用安全等级合规的服务器，获取规范的数据报告，实现重要数据的备份监管。
            </p>
          </div>
          <div class="p-service-right p-service">
            <span class="p-round p-round-two"></span>
            <span class="p-round"></span>
            <p class="p-service-head">建立同一的医生协作平台</p>
            <p class="p-service-text">
              医生通过医生端APP与院内院外医生互动，有效实现跨区域互动社交，实现医生的社交需求，促成会诊合作团队的广泛建成。
            </p>
          </div>
        </div>
      </div>
      <!-- 互联网医院系统 -->
      <div class="p-system p-hospital">
        <p>TELEMEDICINE SYSTEM</p>
        <p class="p-system-title">互联网医院系统</p>
        <img src="./../../../assets/Pc/product2.png" alt="">
        <p class="p-system-title">产品优势</p>
        <div class="p-content">
          <div class="p-service-right">
            <span class="p-round p-round-two"></span>
            <span class="p-round"></span>
            <p class="p-service-head">数据信息统一化</p>
            <p class="p-service-text">
              基于各业务场景的需求，建设统一支付平台、统一患者信息管理平台、统一电子病历平台，实施标准化基础数据管理。
            </p>
          </div>
          <div class="p-service-right">
            <span class="p-round p-round-two"></span>
            <span class="p-round"></span>
            <p class="p-service-head">丰富医疗服务内容</p>
            <p class="p-service-text">
              巩固医疗机构现有基础服务，同时发挥互联网医院体制优势，推动健康管理和私人医生等服务。通过数据化运营，使智能化医疗服务逐渐具备可实施性。
            </p>
          </div>
          <div class="p-service-right p-service">
            <span class="p-round p-round-two"></span>
            <span class="p-round"></span>
            <p class="p-service-head">拓展医疗资源辐射范围</p>
            <p class="p-service-text">
              基于医联体、远程协作等服务，互联网医疗服务具备推广优势，可将优质医疗资源带入更广范围。
            </p>
          </div>
        </div>
      </div>
    </div>
    <PcFooter></PcFooter>
  </div>
</template>

<script>
import PcHead from '@/components/Pc/Head.vue';
import PcFooter from '@/components/Pc/Footer.vue';
export default {
  components:{
    PcHead,
    PcFooter
  }
}
</script>

<style lang="less" scoped>
.p-warp{
  width:1000px;
  margin:0 auto;
}
.p-title{
  font-size:24px;
  color:#333;
  text-align:center;
}
.p-img{
  text-align:center;
  margin:44px 0 42px 0;
}
.p-gif {
  width: 30px;
  margin: 42px auto 30px;
  display: block;
}
.p-system{
  text-align:center;
  p:nth-child(1){
    font-size:18px;
    font-family:PangMenZhengDao;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:18px;
    background:linear-gradient(177deg,rgba(61,170,246,1) 7.5439453125%, rgba(174,195,255,1) 99.5849609375%);
    -webkit-background-clip:text;
    -webkit-text-fill-color:transparent;
    margin-bottom:12px;
  }
  .p-system-title{
    font-weight:bold;
    font-size:16px;
    color:#333
  }
  img{
    margin-bottom:36px;
  }
  .p-content{
    width:800px;
    margin:34px auto 0;
  }
  .p-service-right{
    width:801px;
    text-align:left;
    font-size: 14px;font-family:PingFangSC-Medium; line-height: 32px; padding-left: 30px; border-left: 1px dashed #C2E2FF; position: relative;
    .p-round{
      width: 16px; height: 16px; display: block; background: #C2E2FF;border-radius: 50%; position: absolute; left: -8px; top: 6px;
    }
    .p-round-two{
      top: 0;background: white;
    }
    .p-service-head{
      color: #3576E0; font-weight: 500; margin-bottom: 10px;
    }
    .p-service-foot{
      font-size:14px;
      font-family:PingFangSC-Light; padding-bottom: 62px;
      span{
        height: 26px;  line-height: 26px; text-align: center; background: #DEEFFF; color: #3576e0; border-radius: 13px; margin: 18px 31px 0 0; padding: 0 12px;
      }
    }
    .p-service-text{
      font-weight:Light;
      color:#333;
      font-size:14px;
    }
  }
  .p-service{
    border:none;
  }
}
.p-hospital{
  margin:94px 0 104px;
}
</style>